'use strict';

const EditView = require('./Edit.js');
const FormView = require('./Form.js');

module.exports = FormView.extend({
    bindHandlers: function() {
        // we override for EditView since we don't want to validate form
        // to be able to toggle between login and signup form at will
        // this removes form validation when going to next route
        // includes properties like dirty()
        return EditView.prototype.bindHandlers.apply(this, arguments);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/SignupForm.js